import { h, OmiProps } from "omi";

import { NWIcon } from "@/components";

export function NavCategoryTag(props: OmiProps<{ onClick: () => void }>) {
  return (
    <button
      class="pl-2 py-0.5 pr-1 rounded-[6px] border border-gray-300 w-fit text-sm text-secondary inline-flex text-nowrap items-center space-x-1"
      onClick={props.onClick}
    >
      <div>{props.children}</div>
      <NWIcon class="text-quaternary" name="cross" width={12} height={12}></NWIcon>
    </button>
  );
}
